import React, { FunctionComponent, useContext } from 'react';
import styles from './two-column-grid.module.scss';
import classNames from 'classnames/bind';
import Section from '../section/section';
import { SpaceBetweenColumnsType } from '../../typings';
import { DeviceType } from '../../typings';
import { AppStore } from '../../store/app.context';
import { checkDevice, marginBetweenItemsClasses } from '../../utils/utils';

export interface ITwoColumnGridProps {
  containItems: IKontentItem[];
  marginBetweenItems: SpaceBetweenColumnsType;
  wrappOneColumn: DeviceType;
  sameColumnsWidth: boolean;
}

const cx = classNames.bind(styles);

export const TwoColumnGrid: FunctionComponent<ITwoColumnGridProps> = ({
  containItems,
  marginBetweenItems,
  wrappOneColumn,
  sameColumnsWidth
}) => {
  const { state } = useContext(AppStore);
  const { showActiveDevice } = state;
  const marginBetweenItemsClass = marginBetweenItemsClasses(marginBetweenItems);

  const sectionClass = cx({
    ...marginBetweenItemsClass,
    oneColumn: showActiveDevice <= checkDevice(wrappOneColumn),
    sameColumnsWidth: sameColumnsWidth
  });

  return (
    <div className={`${styles.twoColumnGrid} ${sectionClass}`}>
      {containItems.map((item, i) => (
        <Section linkedItem={item} key={i} />
      ))}
    </div>
  );
};
